
define(
	'Header.Menu.View.Site'
, [
		'Header.Menu.View'
	,	'Profile.Model'
	,	'SC.Configuration'
	,	'Header.Profile.View'
	,	'Header.Menu.MyAccount.View'
	,	'GlobalViews.HostSelector.View'
	,	'GlobalViews.CurrencySelector.View'

	,	'header_menu.tpl'

	,	'Backbone'
	,	'Backbone.CompositeView'
	,	'underscore'
	,	'jQuery'
	,	'jQuery.sidebarMenu'
	]
,	function(
		View
	,	ProfileModel
	,	Configuration
	,	HeaderProfileView
	,	HeaderMenuMyAccountView
	,	GlobalViewsHostSelectorView
	,	GlobalViewsCurrencySelectorView

	,	header_menu

	,	Backbone
	,	BackboneCompositeView
	,	_
	,	jQuery
	)
{
	'use strict';

	_.extend(View.prototype, {
			getContext: _.wrap(View.prototype.getContext, function extendContext(fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					var self = this;

					var profile = ProfileModel.getInstance();
					var	is_loading = ProfileModel.getPromise().state() !== 'resolved';
					// console.log('is_loading', is_loading);
					var	is_loged_in = (profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F') || (profile.get('isRecognized') === 'T' && profile.get('name') && profile.get('name').length > 0);
					// console.log('profile', profile);

					var priceLevelMap = Configuration.get('speedmaster.PriceLevelMap');
					var currentpricelevel = null;
					var pricelevel = profile.get('priceLevel');
					var points = 0;

					if(is_loged_in){
						var pointsField = _.find(profile.get('customfields'), function(tisField){ return tisField.name == 'custentity_points'});
						if(pointsField && pointsField.value){
							points = Number(pointsField.value);
						}

						for(var i=0; i<priceLevelMap.length; i++){
							var tisPriceLevel = priceLevelMap[i];
							if(tisPriceLevel.value == pricelevel){
								currentpricelevel = tisPriceLevel;
								break;
							}
						}
					}

					return _.extend(context, {
							customerid: is_loged_in ? profile.get('name').split(' ')[0] : '',
							name: is_loged_in ? profile.get('name').split(' ').splice(1).join(' ') : '',
							currentpricelevel: currentpricelevel,
							points: points,
							showExtendedMenu: !is_loading && is_loged_in
					});
			})
	});
});

